// src/app/core/navigation/navigation.service.ts
import { Injectable, inject, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { sections } from './navigation.config';
import { NavSection } from './navigation.types';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e: NavigationEnd) => e.urlAfterRedirects),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  readonly activeSection = computed(() =>
    this.findActiveSection(this.currentUrl())
  );

  readonly activeSectionConfig = computed((): NavSection | undefined =>
    sections.find(s => s.key === this.activeSection())
  );

  readonly sections = sections;

  private findActiveSection(url: string): string {
    const match = sections.find(s =>
      url === s.basePath || url.startsWith(s.basePath + '/')
    );
    return match?.key ?? 'dashboard';
  }
}
